import { Injectable, ViewContainerRef } from '@angular/core';
import { SimpleTooltip } from '../components/simple-tooltip/simple-tooltip';

@Injectable({
  providedIn: 'root',
})
export class TooltipService {
  private viewContainerRef: ViewContainerRef | null = null;

  setViewContainerRef(vcr: ViewContainerRef) {
    this.viewContainerRef = vcr;
  }

  create(tooltipText: string, anchorName: string, id: string) {
    if (!this.viewContainerRef) {
      throw new Error(
        'TooltipService.create() requires a ViewContainerRef. Ensure a tooltip host component is present and calls setViewContainerRef(...) before creating tooltips.',
      );
    }
    const ref = this.viewContainerRef.createComponent(SimpleTooltip);
    ref.setInput('id', id);
    ref.setInput('anchorName', anchorName);
    ref.setInput('text', tooltipText);
    return ref;
  }
}
